import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import dives from './diveReducer';
import sharedDives from './sharedDivesReducer';
import dive from './diveDataReducer';

export default combineReducers({
    dives,
    sharedDives,
    dive,
    router: routerReducer
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts